exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".jk-footer {\n  position: fixed;\n  width: 100%;\n  right: 0;\n  bottom: 0;\n  height: 2.5em;\n  --bg-opacity: 1;\n  background-color: #f4f7fb;\n  padding-bottom: 16px;\n  padding-top: 8px;\n  -ms-flex-pack: center;\n  justify-content: center;\n  z-index: 50;\n  display: -ms-flexbox;\n  display: flex; }\n\n.jk-footer-image-cursor {\n  cursor: pointer; }\n\ninput[type=\"date\"] {\n  cursor: pointer; }\n\ninput[type=\"date\" i] {\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/index.css
// module chunks = 504